module.exports = "/_next/static/images/Hero@2x-61a4030969e879a887fe272d27701d70.webp";